import Vue from 'vue'
import Router from 'vue-router'
const routerOptions = [
  { path: '/', component: 'Demo' },
  { path: '/admin', component: 'Admin' },
  { path: '/login', component: 'Login' },
  { path: '/describe', component: 'Describe' },
  { path: '/freeflow', component: 'Freeflow' },
  { path: '/blog', component: 'Blog' },
  { path: '*', component: 'NotFound' }
]
const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})
Vue.use(Router)
export default new Router({
  routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js